angular.module('rjmNg.directives').directive "triStateCheckbox", [
  "cbiTriStateCheckbox"
  (
    triStateCheckbox
  ) ->
    bindToController: true
    controllerAs: "view"
    restrict: "E"
    scope:
      state: "="
      value: "="
      onClick: "&"
    template: "<label class='tri-state-checkbox'><input type='checkbox'>{{::view.value}}</label>"
    controller: [
      () ->

        view = @

        view

    ]
    link: (scope, element) ->
      view = scope.view

      element.find("input").click (event) ->
        event.preventDefault()
        event.stopImmediatePropagation()
        scope.$applyAsync () ->
          view.onClick?()

      scope.$watch "view.state", () ->
        input = element.find("input")[0]

        if view.state is triStateCheckbox.STATES.UNCHECKED
          input.checked = false
          input.indeterminate = false

        else if view.state is triStateCheckbox.STATES.INDETERMINATE
          input.checked = false
          input.indeterminate = true

        else
          input.checked = true
          input.indeterminate = false

]
